import { connect } from 'react-redux';
import ConsumerOverviewView from './ConsumerOverviewView';
import * as selector from './ConsumerOverviewSelector';
import * as actions from './ConsumerOverviewActions';
import {
  currentClientSelector,
  hasAccessToLinkAccountsSelector,
  isAdviserArea as isAdviserAreaSelector,
  isFinancialPlanEnabledSelector,
  selectPortalName,
  showNetWorthSelector,
} from '../CommonSelectors/CommonAreaSelector';
import { executiveSummaryMessageSelector } from '../ExecutiveSummary/ExecutiveSummarySelector';
import { setCurrentView, setRedirectUrl } from '../UpsertAccountModal/UpsertAccountModalActions';
import { fetchNetWorthData } from '../ContextualSidebar/NetWorthSidebar/NetWorthSidebarActions';

import { VIEWS } from '../UpsertAccountModal/UpsertAccountModalConstants';
import { hasDataAggregationSelector as adviserHasDataAggregationSelector } from '../AdviserArea/AdviserAreaSelector';
import { hasDataAggregationSelector as consumerHasDataAggregationSelector } from '../ConsumerArea/ConsumerAreaSelector';

const mapStateToProps = state => {
  const currentClient = currentClientSelector(state);
  const isAdviserArea = isAdviserAreaSelector(state);

  const hasDataAggregation = isAdviserArea
    ? adviserHasDataAggregationSelector(state)
    : consumerHasDataAggregationSelector(state);

  return {
    showExecutiveSummary: !!executiveSummaryMessageSelector(state),
    currentClient: currentClientSelector(state),
    isExecutiveSummaryInitialized: selector.isSummaryInitializedSelector(state),
    hasPersonalFinances: selector.hasPersonalFinancesSelector(state),
    hasFinancialPlanning: selector.hasFinancialPlanningSelector(state),
    canAccessCurrentFinances:
      isAdviserArea || (currentClient.ModulesToHide || []).indexOf('CurrentFinances') < 0,
    canAccessFinancialPlan:
      isFinancialPlanEnabledSelector(state) &&
      (isAdviserArea || (currentClient.ModulesToHide || []).indexOf('FinancialPlan') < 0),
    hasCashflow: (currentClient.OptOuts || []).indexOf('CashFlow') < 0,
    hasDataAggregation,
    hasAccessToLinkAccounts: hasAccessToLinkAccountsSelector(state),
    showNetWorth: showNetWorthSelector(state),
    portalName: selectPortalName(state),
  };
};

const mapDispatchToProps = dispatch => ({
  fetchSummary(clientId) {
    dispatch(actions.fetchSummary(clientId));
  },

  openAddAccountModal() {
    dispatch(setCurrentView(VIEWS.ADD));
    dispatch(setRedirectUrl('ProfileAccounts'));
  },

  fetchNetWorthData(clientId) {
    dispatch(fetchNetWorthData(clientId, true));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ConsumerOverviewView);
